export const EVENT_CONSTANTS = {
    LOAN_CALCULATOR_CDP_ACTION: "Loan_calculator_CDP_action"
};

export const EVENT_DATA = {
    LOAN_CALCULATOR_CDP_ACTION: {
        eventCategory: "CDP Desktop variant B",
        eventAction: "Loan_calculator_CDP_action",
        eventLabel: "Calculator_CDP_get_pre_approval_clicked",
        event: "custom_event"
    }
};
